import tagCanvas from "tag-canvas";
import { useEffect } from "react";
import { tags } from "../tags";

export default function Globe() {
  const tagGlobe = () => {
    try {
      tagCanvas.Start("globe", "tags", {
        textColour: "#ffd66b",
        reverse: true,
        depth: 0.1,
        maxSpeed: 0.1,
        outlineMethod: "none",
        textHeight: 29,
        wheelZoom: false,
      });
    } catch (e) {
      // if something went wrong, hide the globe container
      document.getElementById("globeContainer").style.display = "none";
    }
  };

  useEffect(() => {
    tagGlobe();
  }, []);

  return (
    <>
      <div id="globeContainer">
        <canvas width="400" height="400" style={{ width: "100%" }} id="globe">
          <p>"Failed to load skill globe :("</p>
        </canvas>
      </div>
      <div id="tags" style={{ display: "none" }}>
        <ul>
          {tags.map((tag, index) => (
            <li key={index}>
              <a href="/" onClick={(e) => e.preventDefault()}>{tag}</a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
